// ResourceLoader.js - 资源加载工具类
// 用于减少 preloader.js 中的重复代码
import DebugHelper from './DebugHelper.js';

export default class ResourceLoader {
    /**
     * 批量加载精灵图
     * @param {Phaser.Scene} scene - Phaser场景对象
     * @param {Array} resources - 资源配置数组 [{key, path, width, height}, ...]
     */
    static loadSpritesheets(scene, resources) {
        if (!scene || !scene.load) {
            DebugHelper.error('ResourceLoader: 无效的场景对象');
            return;
        }
        
        resources.forEach(res => {
            const config = {
                frameWidth: res.width || 32,
                frameHeight: res.height || 32
            };
            
            scene.load.spritesheet(res.key, res.path, config);
        });
    }
    
    /**
     * 批量加载图片
     * @param {Phaser.Scene} scene - Phaser场景对象
     * @param {Array} resources - 资源配置数组 [{key, path}, ...]
     */
    static loadImages(scene, resources) {
        if (!scene || !scene.load) {
            DebugHelper.error('ResourceLoader: 无效的场景对象');
            return;
        }
        
        resources.forEach(res => {
            scene.load.image(res.key, res.path);
        });
    }
    
    /**
     * 批量加载音频
     * @param {Phaser.Scene} scene - Phaser场景对象
     * @param {Array} resources - 资源配置数组 [{key, path}, ...]
     */
    static loadAudios(scene, resources) {
        if (!scene || !scene.load) {
            DebugHelper.error('ResourceLoader: 无效的场景对象');
            return;
        }
        
        resources.forEach(res => {
            scene.load.audio(res.key, res.path);
        });
    }
    
    /**
     * 批量加载JSON数据
     * @param {Phaser.Scene} scene - Phaser场景对象
     * @param {Array} resources - 资源配置数组 [{key, path}, ...]
     */
    static loadJSONs(scene, resources) {
        if (!scene || !scene.load) {
            DebugHelper.error('ResourceLoader: 无效的场景对象');
            return;
        }
        
        resources.forEach(res => {
            scene.load.json(res.key, res.path);
        });
    }
    
    /**
     * 使用默认尺寸批量加载精灵图（32x32）
     * @param {Phaser.Scene} scene - Phaser场景对象
     * @param {Array} resources - 资源配置数组 [{key, path}, ...] 或 [key, path] 格式
     */
    static loadSpritesheetsDefault(scene, resources) {
        if (!scene || !scene.load) {
            DebugHelper.error('ResourceLoader: 无效的场景对象');
            return;
        }
        
        resources.forEach(res => {
            let key, path;
            
            // 支持两种格式：[{key, path}, ...] 或 [key, path]
            if (typeof res === 'object') {
                key = res.key;
                path = res.path;
            } else if (Array.isArray(res)) {
                key = res[0];
                path = res[1];
            } else {
                DebugHelper.warn('ResourceLoader: 无效的资源格式', res);
                return;
            }
            
            scene.load.spritesheet(key, path, {
                frameWidth: 32,
                frameHeight: 32
            });
        });
    }
}

